define.alias("ember-power-select/components/power-select", "settings/components/power-select");